import React from 'react';
import useTheme from 'branding/theme';
const TabGroup = ({ children, align = 'start', fullWidth = false, inverted = false, styles }) => {
    const { utility } = useTheme();
    const processedChildren = React.Children.map(children, (child, i) => {
        return (React.createElement(child.type, { ...child, ...child.props, styles: { ...child.props.styles, ...(i !== 0 && { marginLeft: '3.8rem' }) }, inverted: inverted }));
    });
    const mergedStyles = {
        display: 'inline-flex',
        justifyContent: align === 'center' ? align : `flex-${align}`,
        ...(fullWidth && utility.size.fullWidthStyles),
        ...styles
    };
    return React.createElement("nav", { style: mergedStyles }, processedChildren);
};
export default TabGroup;
//# sourceMappingURL=index.js.map